import type { TranslationDict } from './ja'

export const es: TranslationDict = {
  appTitle: 'Lucky Animal Territory',
  help: 'Cómo jugar',
  helpAria: 'Cómo jugar',
  settings: 'Ajustes',
  settingsAria: 'Ajustes',
  close: 'Cerrar',
  closeAria: 'Cerrar',
  player: 'Jugador',
  highscore: 'Récord',
  start: 'Empezar',
  staminaEmpty: 'No hay energía suficiente',
  ranking: 'Batalla de Territorio',
  difficultyTitle: 'Elige dificultad',
  difficultyStart: 'Empezar con esta dificultad',
  back: 'Volver',
  today: 'Hoy',
  weekly: 'Esta semana',
  alltime: 'General',
  loading: 'Cargando...',
  noScores: 'Aún no hay resultados. ¡Sé el primer campeón!',
  loadFailed: 'No se pudo cargar',
  you: 'Tú',
  youConstant: 'TÚ',
  language: 'Idioma',
  languageNote: 'Compatible con 18 idiomas, incluido japonés.',
  bgm: 'BGM',
  se: 'Efectos',
  soundEnableAria: 'Activar sonido',
  soundDisableAria: 'Desactivar sonido',
  adWatch: 'Ver anuncio completo',
  adCancel: 'Ahora no',
  rankSuffix: 'º',
  earnedPoints: 'ganó {score} pts',
  helpGoalTitle: '🎯 Objetivo',
  helpGoalText: 'Coloca piezas en el tablero de 9x9 y expande tus territorios conectados. El que tenga la puntuación más alta gana.',
  helpWinTitle: '🏆 Condiciones de victoria',
  helpWinFive: 'Haz cinco en raya vertical, horizontal o diagonalmente para ganar al instante.',
  helpWinScore: 'Si el tablero se llena, gana la puntuación más alta. No hay empates.',
  helpScoreTitle: '💯 Puntuación',
  helpLineBonus: 'Bonos de línea: obtén puntos por líneas de 3, 4 y 5 en raya.',
  helpClusterBonus: 'Bono de territorio: puntúa más a medida que crecen tus grupos conectados.',
  helpKomi: 'Komi: el segundo jugador obtiene un hándicap de puntuación del +10%.',
  helpControlsTitle: '🖱️ Controles',
  helpControlsText: 'En tu turno, toca una celda vacía para colocar una pieza.',
  helpTipsTitle: '💡 Consejos',
  helpTipHell: 'Prueba HELL cuando quieras el desafío más difícil.',
  helpTipCluster: 'No solo busques cinco en raya. Los grupos conectados más grandes también aumentan tu puntuación.',
  resultWinFive: '🎉 ¡Cinco en raya! ¡Ganaste!',
  resultWinScore: '🎉 ¡Victoria por puntos! ¡Ganaste!',
  resultLoseFive: '😿 ¡La CPU hizo cinco en raya!',
  resultLoseScore: '😿 Derrota por puntos. ¡Inténtalo de nuevo!',
  resultDraw: '🤝 Empate',
  newHighscore: '🏆 ¡Nuevo récord!',
  scoreNone: 'Sin puntuación',
  clusterBonus: 'Bono de territorio',
  retry: 'Jugar de nuevo',
  titleBack: 'Título',
  scoreHintPlaceStone: 'Coloca una piedra',
  best: 'Mejor',
  clusterUnit: 'territorio',
  lineCount: '{len} en raya x{count}',
  turnCount: 'Movimiento {count} · {difficulty}',
  boardPlayerPiece: 'Tu pieza',
  boardCpuPiece: 'Pieza de la CPU',
  boardPlayerAlt: 'Tú',
  boardCpuAlt: 'CPU',
  boardCellPosition: 'fila {row}, columna {col}',
  boardPlaceable: 'colocable',
  boardEmpty: 'celda vacía',
  boardFlower: 'tiene flor',
  firstPlayerAlt: 'Primer jugador',
  playerFirst: '¡Empiezas tú!',
  playerSecond: 'Vas de segundo (+{bonus}% komi)',
  cpuFirst: '¡La CPU empieza!',
  finalePlayerWin: '¡Ganaste!',
  finaleCpuWin: '¡Gana la CPU!',
  finaleFive: '¡Cinco en raya!',
  finaleTerritory: '¡Batalla de territorios!',
  winnerAlt: 'Ganador',
  loadingBoot: 'Iniciando...',
  loadingConnect: 'Conectando...',
  loadingProfile: 'Cargando perfil...',
  loadingAssets: 'Cargando recursos...',
  loadingReady: 'Listo',
  reauthRequiredTitle: 'Sesión requerida',
  startupFailedTitle: 'Error de inicio',
  reauthButton: 'Iniciar sesión de nuevo',
  reloadButton: 'Recargar',
  lineReloginButton: 'LINE login',
  reauthReason: 'Tu sesión ha caducado. Por favor, inicia sesión de nuevo.',
  errorReauth: 'Tu sesión ha caducado. Por favor, inicia sesión de nuevo.',
  errorForbidden: 'No tienes permiso para usar este juego.',
  errorNotFound: 'No se encontraron datos del juego.',
  errorRateLimited: 'La red está ocupada. Por favor, espera e inténtalo de nuevo.',
  errorServer: 'No se pudo conectar al servidor. Por favor, espera y recarga.',
  errorCommunication: 'Ocurrió un error de comunicación. Por favor, recarga.',
  errorNetwork: 'No se pudo conectar a la red. Revisa tu conexión y recarga.',
  errorStartup: 'Error al iniciar. Por favor, recarga.',
  settingsTabGeneral: 'Ajustes',
  settingsTabAccount: 'Cuenta',
  settingsTabInfo: 'Info',
  account: 'Cuenta',
  linked: 'Vinculado',
  guest: 'Invitado',
  loggedInWith: 'Sesión iniciada con {provider}',
  loggedIn: 'Sesión iniciada',
  playingAsGuest: 'Estás jugando como invitado.',
  appleLoginBusy: 'Iniciando sesión con Apple...',
  appleLogin: 'Iniciar sesión con Apple',
  googleLoginBusy: 'Iniciando sesión con Google...',
  googleLogin: 'Iniciar sesión con Google',
  logoutBusy: 'Cerrando sesión...',
  logout: 'Cerrar sesión',
  logoutSuccess: 'Sesión cerrada',
  logoutFailed: 'Error al cerrar sesión',
  appInfo: 'Información de la aplicación',
  appName: 'Nombre de la aplicación',
  version: 'Versión',
  legalInfo: 'Información legal',
  terms: 'Términos de uso',
  privacy: 'Política de privacidad',
  operator: 'Operador',
  contact: 'Contacto',
  copyTap: 'Toca para copiar',
  idCopied: 'ID copiado',
  copyFailed: 'Error al copiar',
  other: 'Otros',
  reportAd: 'Informar de anuncio inapropiado',
  privacyChoices: 'Ad privacy choices',
  profileEdit: 'Editar perfil',
  displayName: 'Nombre mostrado',
  displayNamePlaceholder: 'Introduce un nombre',
  chooseIcon: 'Elegir icono',
  iconLoadFailed: 'Error al cargar los iconos.',
  saveFailed: 'Error al guardar. Inténtalo de nuevo.',
  noIcons: 'No hay iconos disponibles.',
  save: 'Guardar',
  saving: 'Guardando...',
  staminaAria: 'Energía {stamina} / {max}',
  nextRecovery: 'Siguiente recuperación en {time}',
  adPlaying: 'Reproduciendo anuncio...',
  recoverFullAd: 'Ver anuncio para recuperar toda la energía',
  dailyBonusAria: 'Ver anuncio completo para obtener +5 de energía',
  dailyBonusAd: 'Ver anuncio para obtener +5 de energía',
  legalLastUpdated: 'Última actualización: {date}',
  privacyTitle: 'Política de privacidad',
  termsTitle: 'Términos de uso',
  adPlayingAria: 'Anuncio reproduciéndose',
  adBadge: '▶ Anuncio',
  adRemaining: 'Quedan {seconds}s',
  adDevHint: 'Anuncio de prueba. En producción, se reproducirá un video de AdMob.',
  adRewardRequirement: 'Mira el anuncio completo para recibir esta recompensa.',
  adRewardStaminaDetail: 'Recompensa: recuperar la energía hasta el máximo',
  adRewardDailyBonusDetail: 'Recompensa: +{amount} de energía como bono diario',
  adRewardIncompleteNote: 'Si lo cierras antes de terminar, no recibirás la recompensa.',
  adSkipAria: 'Saltar anuncio',
  adSkip: 'Saltar ✕',
  adSkipAfter: 'Saltar en {seconds}s',
  offlineMessage: 'No se puede conectar al servidor. Algunas funciones no estarán disponibles.',
  reconnecting: 'Reconectando...',
  reconnect: 'Reconectar',
  signInTitle: 'Iniciar sesión',
  signInBusy: 'Iniciando sesión...',
  signInCancelNote: 'Si cancelas el inicio de sesión, puedes continuar como invitado. Algunas funciones no estarán disponibles.',
  processing: 'Procesando...',
  recoverConfirmTitle: 'Confirmar reemplazo de datos',
  recoverConfirmMessage: 'Ya existen datos vinculados a este inicio de sesión. Si continúas, se reemplazarán los datos de invitado en este dispositivo. ¿Deseas continuar?',
  recoverConfirmContinue: 'Restaurar',
  recoverConfirmCancel: 'Cancelar',
  unlinkConfirmTitle: 'Desvincular cuenta',
  unlinkConfirmMessage: 'Si desvinculas este proveedor, este dispositivo volverá al modo de juego como invitado. Tus datos del Hub seguirán disponibles si vuelves a iniciar sesión con el mismo proveedor en otro dispositivo.',
  unlinkConfirmContinue: 'Desvincular',
  unlinkConfirmCancel: 'Cancelar',
  deleteConfirmTitle: 'Confirmar eliminación de cuenta',
  deleteConfirmMessage: 'Eliminar tu cuenta borrará tus récords, datos de inicio de sesión, cuentas vinculadas e invitaciones.\nEsta acción no se puede deshacer. ¿Realmente quieres eliminarla?',
  deleteConfirmContinue: 'Eliminar cuenta',
  deleteConfirmCancel: 'Cancelar',
  adNekoTitle: 'AD Neko',
  matchmakingRemaining: 'Quedan {seconds}s',
  matchmakingTimeoutMessage: 'No se encontró oponente a tiempo. Por favor, inténtalo de nuevo.',
  difficultyEasyName: 'Casual',
  difficultyEasyDescription: 'El oponente está un poco distraído',
  difficultyNormalName: 'Normal',
  difficultyNormalDescription: 'El oponente a veces comete errores',
  difficultyHardName: 'Difícil',
  difficultyHardDescription: 'El oponente ve más del tablero',
  difficultyHellName: 'Extremo',
  difficultyHellDescription: 'El oponente es fuerte y lee tus movimientos',
}
